import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";
import type { DrillDownConditionGroupNode, DrillDownConditionNode } from "../../../../../hooks/drillDownConditions.ts";

interface Props {
  condition: DrillDownConditionGroupNode;
  renderNode: (condition: DrillDownConditionNode) => ReactNode;
}

export default function DrillDownConditionGroup({ condition, renderNode }: Props) {
  if (condition.conditions.length === 0) {
    return null;
  }

  if (condition.conditions.length === 1) {
    const [nestedCondition] = condition.conditions;
    if (!nestedCondition) {
      return null;
    }

    return <>{renderNode(nestedCondition)}</>;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "background.grey",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: "2px",
          p: 1,
        }}
      >
        <Typography
          variant="body2"
          color="textDisabled"
          sx={{
            fontSize: "12px",
            lineHeight: 1.4,
            letterSpacing: "0.17px",
            textTransform: "capitalize",
            flexShrink: 0,
          }}
        >
          {condition.operator.toLowerCase()}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flex: 1, minWidth: 0 }}>
          {condition.conditions.map((nestedCondition) => renderNode(nestedCondition))}
        </Box>
      </Box>
    </Box>
  );
}
